import type { Resource } from '../../';
export const account_authenticated_logout: Resource = {"default":"Logout"};
